import { render, staticRenderFns } from "./filter-card.vue?vue&type=template&id=4457ab1f&"
import script from "./filter-card.vue?vue&type=script&lang=ts&"
export * from "./filter-card.vue?vue&type=script&lang=ts&"
import style0 from "./filter-card.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports